import App from "./App.vue";
import router from "./router";
import { http } from "./http";
import store from "./store";
import "./registerServiceWorker";
import { sync } from "vuex-router-sync";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import ApiService from "./common/api.service";
import Vue from "vue";
import Vuelidate from "vuelidate";

// Sync router to store, as `store.state.route`
sync(store, router);

Vue.config.productionTip = false;
Vue.use(http);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);

ApiService.init();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
